/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // FJS promo badge: snippets/product-price.liquid renders a "SAVE 20%"
  // badge next to the price on the PDP for specific products/variants,
  // showing/hiding it based on data-promo-variant-ids. The theme fires
  // theme:variant:change (bubbling) on the product section whenever the
  // shopper picks a different variant, so keep the badge in sync with that.
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var container = event.target;
    if (!variant || !container) return;

    container.querySelectorAll('[data-promo-badge][data-promo-variant-ids]').forEach(function (badge) {
      var ids = (badge.getAttribute('data-promo-variant-ids') || '').split(',');
      if (ids.indexOf(String(variant.id)) !== -1) {
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    });
  });
})();